import { RefObject, useEffect } from 'react';

export function useClickOutside(ref: RefObject<HTMLElement>, handler?: (event: MouseEvent | TouchEvent) => void) {
	useEffect(() => {
		const handleClickOutside = (event: MouseEvent | TouchEvent) => {
			if (ref.current && !ref.current.contains(event.target as Node)) {
				handler?.(event);
			}
		};

		document.addEventListener('mousedown', handleClickOutside);
		document.addEventListener('touchstart', handleClickOutside);

		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
			document.removeEventListener('touchstart', handleClickOutside);
		};
	}, [ref, handler]);
}
